import { referFriendStoreKey } from './referFriend.const';
import { IReferFriendSliceState } from './referFriend.slice';

interface IState {
  [referFriendStoreKey]: IReferFriendSliceState;
}

const selectReferFriendState = (state: IState) => {
  return state[referFriendStoreKey];
};

const getReferrerAPIData = (state: IState) => {
  return selectReferFriendState(state).referrer;
};

const getReferrerCountryOptions = (state: IState) => {
  return selectReferFriendState(state).countries;
};

const getReferralSubmitName = (state: IState) => {
  return selectReferFriendState(state).referralName;
};

const getAuthEmailSentTo = (state: IState) => {
  return selectReferFriendState(state).authEmailSentTo;
};

const getReferrerIsPerformingAction = (state: IState) => {
  return selectReferFriendState(state).isPerformingAction;
};

const getReferralSubmitWasRejected = (state: IState): boolean => {
  return selectReferFriendState(state).wasRejected;
};

const getReferralInProcess = (state: IState): boolean => {
  return selectReferFriendState(state).inProcess;
};

export const referFriendSelectors = {
  getReferrerAPIData,
  getReferrerCountryOptions,
  getReferralSubmitName,
  getAuthEmailSentTo,
  getReferrerIsPerformingAction,
  getReferralSubmitWasRejected,
  getReferralInProcess,
};
